import React, { Component } from "react";
import { PageHeader, Spin, Row, Col, message } from "antd";
import moment from "moment";
import "moment/locale/es";
import {
    Select
} from "antd"

// Ajusta estos imports a tus rutas reales
import {
    Form,
    FormItem,
    InputItem,
    TextAreaItem,
    SelectItem,
    InputNumberItem,
    SwitchItem,
    ButtonItem,
    HeaderItem,
    BoxItem,
    ErrorItem,
    SelectInsumosItem,
} from "../../../../Components/Items";
import { connect } from "react-redux";
import axios from "axios";

const { Option } = Select || {}; // por si SelectItem es wrapper

moment.locale("es");

class EditarConteoCiclico extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
        objetoProyectos: null,
        objetoUsuarios: null,
        id: this.props?.location?.state?.id,
    };

    componentDidMount() {
        if(!this.state.id){
            message.error("No se recibió el ID del conteo cíclico a editar");
            this.props.history.push("/panel/conteosCiclicos");
            return;
        }
        this.consultarTodo();
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "conteosCiclicos/selectDatosParaConteoCiclico",
                { 
                    empresaId: this.props.empresaId ,
                    conteoCiclicoId: this.state.id,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState(
                        {
                            todasProyectos: res.data.proyectos,
                            todasUsuarios: res.data.usuariosEmpresa,
                            objetoProyectos: res.data.proyectos.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre}
                                    </Option>
                                );
                            }),
                            objetoUsuarios: res.data.usuariosEmpresa.map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre +
                                            " " +
                                            value.apellidoPaterno +
                                            " " +
                                            value.apellidoMaterno}
                                    </Option>
                                );
                            }),
                            objetoFamilias: (res.data.familias || []).map((value) => {
                                return (
                                    <Option value={value._id} key={value._id}>
                                        {value.nombre}
                                    </Option>
                                );
                            }),
                        },
                    );

                    // Llena el formulario con los datos existentes
                    this.formRef.current.setFieldsValue(res.data.conteoCiclico);

                } else {
                    message.error(res.data.message || "Error al consultar datos para insumo");
                }
            });
        this.setState({ loading: false });
    }


    atras() {
        this.props.history.goBack();
    }

    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "conteosCiclicos/editarConteoCiclico",
                {
                    ...values,
                    empresaId: this.props.empresaId,
                    conteoCiclicoId: this.state.id,
                },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Conteo cíclico editado exitosamente");
                    this.atras();
                } else if (res.data.success === 1) {
                    message.error("No se pudo editar el conteo cíclico");
                } else {
                    message.error("Sucedió un error y no se pudo editar el conteo cíclico");
                }
            })
            .catch((error) => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });

    }

    onFinishFailed(e) {
        ErrorItem(e);
    };

    render() {
        return (
            <>
                <PageHeader
                    onBack={this.atras.bind(this)}
                    title="Editar Conteo Cíclico"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />

                <div className="card-background" style={{ paddingTop: 5 }}>
                    <Spin spinning={this.state.loading}>
                        <Form
                            ref={this.formRef}
                            name="editarConteoCiclico"
                            layout
                            initialValues={{
                                frecuencia: "Semanal",
                                requiereAprobacionSupervisor: false,
                                modoConteo: 2, // Semi-Ciego default (cámbialo si quieres)
                                estrategiaSeleccionInsumos: 1, // Mas Rotacion default
                            }}
                            bottom={
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Guardar
                                </ButtonItem>
                            }
                            onFinish={this.onFinish.bind(this)}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Row gutter={[16, 16]}>
                                {/* Col Izquierda */}
                                <Col span={14} xs={24} sm={24} lg={14} xl={14}>
                                    <HeaderItem>DATOS GENERALES</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            name="nombre"
                                            label="Nombre"
                                            required
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                            pattern
                                        >
                                            <InputItem placeholder="Nombre del conteo" />
                                        </FormItem>

                                        <FormItem
                                            name="descripcion"
                                            label="Descripción"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                            pattern
                                        >
                                            <TextAreaItem placeholder="Descripción (opcional)" rows={3} />
                                        </FormItem>

                                        <FormItem
                                            name="proyectoId"
                                            label="Proyecto"
                                            required
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem allowClear placeholder="Seleccione un proyecto...">
                                                {this.state.objetoProyectos}
                                            </SelectItem>
                                        </FormItem>

                                        <FormItem
                                            name="supervisorId"
                                            label="Supervisor"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem allowClear placeholder="Seleccione supervisor...">
                                                {this.state.objetoUsuarios}
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            name="requiereAprobacionSupervisor"
                                            label="Requiere aprobación"
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                            valuePropName="checked"
                                        >
                                            <SwitchItem />
                                        </FormItem>

                                        <FormItem
                                            name="responsablesIds"
                                            label="Responsables"
                                            required
                                            margin
                                            labelCol={{ span: 5 }}
                                            wrapperCol={{ span: 19 }}
                                        >
                                            <SelectItem
                                                mode="multiple"
                                                allowClear
                                                placeholder="Seleccione responsables..."
                                            >
                                                {this.state.objetoUsuarios}
                                            </SelectItem>
                                        </FormItem>
                                    </BoxItem>

                                </Col>

                                {/* Col Derecha */}
                                <Col span={10} xs={24} sm={24} lg={10} xl={10}>
                                    <HeaderItem>PARÁMETROS DE CONTEO</HeaderItem>
                                    <BoxItem>
                                        <FormItem
                                            name="modoConteo"
                                            label="Modo de conteo"
                                            required
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Modo en que se realizará el conteo. Ciego: Los responsables no ven las cantidades actuales. Semi-Ciego: Los responsables ven las cantidades actuales después de ingresar su conteo. Abierto: Los responsables ven las cantidades actuales desde el inicio."
                                        >
                                            <SelectItem placeholder="Seleccione...">
                                                <Option value={1}>Ciego</Option>
                                                <Option value={2}>Semi-Ciego</Option>
                                                <Option value={3}>Abierto</Option>
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            name="estrategiaSeleccionInsumos"
                                            label="Estrategia"
                                            required
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Estrategia de selección de insumos para el conteo."
                                        >
                                            <SelectItem placeholder="Seleccione...">
                                                <Option value={1}>Más rotación</Option>
                                                <Option value={2}>Menos rotación</Option>
                                                <Option value={3}>Aleatorio (Alguna vez existente)</Option>
                                                <Option value={4}>Aleatorio (Todos)</Option>
                                                <Option value={5}>Todos</Option>
                                                <Option value={6}>Todos con existencia</Option>
                                                <Option value={7}>Insumos específicos</Option>
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            name="familiaIds"
                                            label="Familias"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Filtro opcional: acota la estrategia seleccionada a solo estas familias de insumos."
                                        >
                                            <SelectItem mode="multiple" allowClear placeholder="Todas las familias...">
                                                {this.state.objetoFamilias}
                                            </SelectItem>
                                        </FormItem>
                                        <FormItem
                                            noStyle
                                            shouldUpdate={(prev, curr) => prev.estrategiaSeleccionInsumos !== curr.estrategiaSeleccionInsumos}
                                        >
                                            {({ getFieldValue }) => {
                                                const estrategia = getFieldValue("estrategiaSeleccionInsumos");
                                                if (estrategia !== 7) return null;
                                                return (
                                                    <FormItem
                                                        name="insumosSeleccionadosIds"
                                                        label="Insumos"
                                                        required
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 17 }}
                                                        tooltip="Selecciona exactamente los insumos que se contarán."
                                                    >
                                                        <SelectInsumosItem
                                                            mode="multiple"
                                                            tiposInsumos="inventariables"
                                                            empresaId={this.props.empresaId}
                                                            headersToken={this.props.headersToken}
                                                            placeholder="Buscar insumos..."
                                                        />
                                                    </FormItem>
                                                );
                                            }}
                                        </FormItem>
                                        <FormItem
                                            name="ventanaDiasEstrategia"
                                            label="Ventana (días)"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Número de días hacia atrás para calcular la rotación de insumos. No funciona con estrategias aleatorias."
                                        >
                                            <InputNumberItem
                                                placeholder="Ej: 30"
                                                min={0}
                                            />
                                        </FormItem>
                                        <FormItem
                                            noStyle
                                            shouldUpdate={(prev, curr) => prev.estrategiaSeleccionInsumos !== curr.estrategiaSeleccionInsumos}
                                        >
                                            {({ getFieldValue }) => {
                                                const estrategia = getFieldValue("estrategiaSeleccionInsumos");
                                                if (estrategia === 5 || estrategia === 6 || estrategia === 7) return null;
                                                return (
                                                    <FormItem
                                                        name="capacidadPorResponsable"
                                                        label="Capacidad / responsable"
                                                        required
                                                        margin
                                                        labelCol={{ span: 7 }}
                                                        wrapperCol={{ span: 17 }}
                                                        tooltip="Número de insumos que cada responsable contará por ciclo."
                                                    >
                                                        <InputNumberItem placeholder="Ej: 120" min={1} />
                                                    </FormItem>
                                                );
                                            }}
                                        </FormItem>
                                        <FormItem
                                            name="reconteosPermitidos"
                                            label="Reconteos permitidos"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Número de veces que un responsable puede volver a contar un insumo."
                                        >
                                            <InputNumberItem placeholder="Ej: 2" min={0} />
                                        </FormItem>
                                        <FormItem
                                            name="ventanaDeConteo"
                                            label="Vigencia (días)"
                                            margin
                                            labelCol={{ span: 7 }}
                                            wrapperCol={{ span: 17 }}
                                            tooltip="Días de vigencia que tendrá cada conteo generado. Al generarse el conteo, la fecha de vigencia se calcula como la fecha de generación más estos días. Si se deja vacío, el conteo se genera sin fecha de vigencia."
                                        >
                                            <InputNumberItem placeholder="Ej: 7" min={1} />
                                        </FormItem>
                                    </BoxItem>
                                    <HeaderItem>PROGRAMACIÓN</HeaderItem>
                                    <BoxItem>
                                        <Row gutter={12}>
                                            <Col span={24}>
                                                <FormItem
                                                    name="frecuencia"
                                                    label="Frecuencia"
                                                    required
                                                    margin
                                                    labelCol={{ span: 7 }}
                                                    wrapperCol={{ span: 17 }}
                                                >
                                                    <SelectItem placeholder="Seleccione...">
                                                        <Option value="Diario">Diario</Option>
                                                        <Option value="Semanal">Semanal</Option>
                                                        <Option value="Quincenal">Quincenal</Option>
                                                        <Option value="Mensual">Mensual</Option>
                                                    </SelectItem>
                                                </FormItem>
                                            </Col>
                                        </Row>

                                        {/* Campos condicionales según frecuencia */}
                                        <FormItem
                                            noStyle
                                            shouldUpdate={(prev, curr) => prev.frecuencia !== curr.frecuencia}
                                        >
                                            {({ getFieldValue }) => {
                                                const frecuencia = getFieldValue("frecuencia");

                                                if (frecuencia === "Semanal" || frecuencia === "Quincenal") {
                                                    return (
                                                        <Row gutter={12}>
                                                            <Col span={24}>
                                                                <FormItem
                                                                    name="diasEspecificos"
                                                                    label="Día"
                                                                    required
                                                                    margin
                                                                    labelCol={{ span: 7 }}
                                                                    wrapperCol={{ span: 17 }}
                                                                >
                                                                    <SelectItem mode="multiple" placeholder="Seleccione día...">
                                                                        <Option value="Lunes">Lunes</Option>
                                                                        <Option value="Martes">Martes</Option>
                                                                        <Option value="Miércoles">Miércoles</Option>
                                                                        <Option value="Jueves">Jueves</Option>
                                                                        <Option value="Viernes">Viernes</Option>
                                                                        <Option value="Sábado">Sábado</Option>
                                                                        <Option value="Domingo">Domingo</Option>
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    );
                                                }

                                                if (frecuencia === "Mensual") {
                                                    return (
                                                        <Row gutter={12}>
                                                            <Col span={24}>
                                                                <FormItem
                                                                    name="diasDelMes"
                                                                    label="Día del mes"
                                                                    required
                                                                    margin
                                                                    labelCol={{ span: 7 }}
                                                                    wrapperCol={{ span: 17 }}
                                                                >
                                                                    <SelectItem mode="multiple" placeholder="Seleccione día(s) del mes...">
                                                                        {Array.from({ length: 31 }, (_, i) => i + 1).map((dia) => (
                                                                            <Option value={dia} key={dia}>{dia}</Option>
                                                                        ))}
                                                                    </SelectItem>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    );
                                                }

                                                // Para Diario/Desactivado no se requiere extra
                                                return null;
                                            }}
                                        </FormItem>
                                    </BoxItem>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </div>
            </>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        envios: state.empresa.envios,
        marbetes: state.empresa.marbetes,
        fletes: state.empresa.fletes,
        lotesCaducidades: state.empresa.lotesCaducidades,
        taxidermia: state.empresa.taxidermia,
    };
};

export default connect(mapStateToProps)(EditarConteoCiclico);